const If = ({ condition, children }) => condition
  ? (typeof children === 'function' ? children() : children)
  : null

export default If;



// WEBPACK FOOTER //
// ./src/components/If.js